nodeMarquee({
  parent: '.marquee_neww',
  speed: 1
});


// Featured js ///




  $(document).ready(function () {
  if ($('.slider-fec').children().length > 5) { 
    $('.slider-fec').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      speed: 300,
      infinite: false,
      prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
      autoplaySpeed: 5000,
      autoplay: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }
});



      $(function() {
  $(".js-faq-title").first().addClass("faq__active");
  $(".js-faq-content").first().slideDown(0);
  $('.js-faq-rotate').first().addClass('faq__rotate');
  $(".js-faq-title").on("click", function(e) {
    e.preventDefault();
    var $this = $(this);
    if (!$this.hasClass("faq__active")) {
      $(".js-faq-content").slideUp(800);
      $(".js-faq-title").removeClass("faq__active");
      $('.js-faq-rotate').removeClass('faq__rotate');
    }
    $this.toggleClass("faq__active");
    $this.next().slideToggle();
    $('.js-faq-rotate', this).toggleClass('faq__rotate');
  });
  //END
});




  $(document).ready(function(){
        $('.collection-list_neww').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          speed: 300,
          infinite: false, 
          prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
          autoplaySpeed: 5000,
          autoplay: true,
          responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        }
            ,
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
        });
      });




      $(document).ready(function() {
  function initSlick() {
    if ($(window).width() <= 576) { // Only initialize for mobile screens
      if (!$('.multi_home_columnn .multicolumn-list').hasClass('slick-initialized')) {
        $('.multi_home_columnn .multicolumn-list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          speed: 300,
          prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
          nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
          autoplaySpeed: 5000,
          autoplay: true,
        });
      }
    } else {
      if ($('.multi_home_columnn .multicolumn-list').hasClass('slick-initialized')) {
        $('.multi_home_columnn .multicolumn-list').slick('unslick');
      }
    }
  }

  initSlick();

  $(window).resize(function() {
    initSlick();
  });
});